import { createAction, createReducer } from 'redux-act';
import { API_INSTANCE } from '../../utils/service-http';
import { addToBuyAutomation, addToMyList, addToMyProduct, addToMyProject } from '../../utils/my-product';
import { getAppLocale } from '../../utils/app-locale';
import { api_base_url, front_base_url, m580_distributed_ranges, m580_hotstandby_ranges, possible_starter_selections } from '../../constants';
import { download, downloadURI, downloadConfigurationImages } from '../../utils/download';
import Configuration from '../../models/Configuration';
import IOIsland from '../../models/IOIsland';
import { logAddToBuyAutomationEvent, logAddToMyCartEvent, logAddToMyListEvent, logAddToMyProductEvent, logAddToMyProjectEvent, logExportConfiguration, logXLSEvent } from '../../utils/analytics-logger';
import { appConfiguration } from '../../utils/app-starter';
import { generateIslandImage, generatePacIslandImage, generateSLCImage, generateEdgeIslandImage } from './png_export_helper';
import I10n from '../i10n';

const DEFAULT_STATE_EXPORT = {
  machine_expert: {
    isLoading: false
  },
  xls: {
    isLoading: false
  },
  png: {
    isLoading: false
  },
  my_product: {
    isLoading: false
  },
  aml: {
    isLoading: false
  },

}

export const exportMachineExpertStarted = createAction('EXPORT_MACHINE_EXPERT_STARTED');
export const exportMachineExpertSuccess = createAction('EXPORT_MACHINE_EXPERT_SUCCESS');
export const exportMachineExpertFailed = createAction('EXPORT_MACHINE_EXPERT_FAILED');

export const exportXLSStarted = createAction('EXPORT_XLS_STARTED');
export const exportXLSSuccess = createAction('EXPORT_XLS_SUCCESS');
export const exportXLSFailed = createAction('EXPORT_XLS_FAILED');

export const exportPNGStarted = createAction('EXPORT_PNG_STARTED');
export const exportPNGSuccess = createAction('EXPORT_PNG_SUCCESS');
export const exportPNGFailed = createAction('EXPORT_PNG_FAILED');

export const exportToMyProductStarted = createAction('EXPORT_TO_MY_PRODUCT_STARTED');
export const exportToMyProductSuccess = createAction('EXPORT_TO_MY_PRODUCT_SUCCESS');
export const exportToMyProductFailed = createAction('EXPORT_TO_MY_PRODUCT_FAILED');

export const exportAMLStarted = createAction('EXPORT_AML_STARTED');
export const exportAMLSuccess = createAction('EXPORT_AML_SUCCESS');
export const exportAMLFailed = createAction('EXPORT_AML_FAILED');


export const exportReducer = createReducer(function (on, off) {
  on(exportMachineExpertStarted, (state, payload) => {
    return {
      ...state,
      machine_expert: {
        isLoading: true
      }
    };
  });
  on(exportMachineExpertSuccess, (state, payload) => {
    return {
      ...state,
      machine_expert: {
        isLoading: false
      },
    };
  })
  on(exportMachineExpertFailed, (state, payload) => {
    return {
      ...state,
      machine_expert: {
        isLoading: false
      }
    };
  });
  on(exportPNGStarted, (state, payload) => {
    return {
      ...state,
      png: {
        isLoading: true
      }
    };
  });
  on(exportPNGSuccess, (state, payload) => {
    return {
      ...state,
      png: {
        isLoading: false
      },
    };
  });
  on(exportPNGFailed, (state, payload) => {
    return {
      ...state,
      png: {
        isLoading: false
      }
    };
  });
  on(exportXLSStarted, (state, payload) => {
    return {
      ...state,
      xls: {
        isLoading: true
      }
    };
  });
  on(exportXLSSuccess, (state, payload) => {
    return {
      ...state,
      xls: {
        isLoading: false
      },
    };
  })
  on(exportXLSFailed, (state, payload) => {
    return {
      ...state,
      xls: {
        isLoading: false
      }
    };
  })
  on(exportToMyProductStarted, (state, payload) => {
    return {
      ...state,
      my_product: {
        isLoading: true
      }
    };
  });
  on(exportToMyProductSuccess, (state, payload) => {
    return {
      ...state,
      my_product: {
        isLoading: false
      },
    };
  })
  on(exportToMyProductFailed, (state, payload) => {
    return {
      ...state,
      my_product: {
        isLoading: false
      }
    };
  })
  on(exportAMLStarted, (state, payload) => {
    return {
      ...state,
      aml: {
        isLoading: true
      }
    };
  });
  on(exportAMLSuccess, (state, payload) => {
    return {
      ...state,
      aml: {
        isLoading: false
      },
    };
  })
  on(exportAMLFailed, (state, payload) => {
    return {
      ...state,
      aml: {
        isLoading: false
      }
    };
  })
}, DEFAULT_STATE_EXPORT);

export const exportToMachineExpert = (configuration) => {
  const mainOverrideString = appConfiguration.main ? `&main=${appConfiguration.main}` : '';
  return async dispatch => {
    dispatch(exportMachineExpertStarted());
    return API_INSTANCE.get(`${api_base_url}/configurations/${configuration.id}/export/machine-expert?locale=${getAppLocale()}${mainOverrideString}&t=${new Date().getTime()}`)
      .then((success) => {
        logExportConfiguration(configuration, 'EXPORT_MACHINE_EXPERT', '.py');
        download(`${success.data.payload.filename}.py`,
          success.data.payload.filedata
        );
        dispatch(exportMachineExpertSuccess());
        return success.data.payload;
      }).catch((error) => {
        dispatch(exportMachineExpertFailed());
        throw error;
      });
  }
}

export const exportToXLS = (configuration, step) => {
  const mainOverrideString = appConfiguration.main ? `&main=${appConfiguration.main}` : '';
  return async dispatch => {
    dispatch(exportXLSStarted());
    return API_INSTANCE.get(`${api_base_url}/configurations/${configuration.id}/export/xls?locale=${getAppLocale()}${mainOverrideString}&t=${new Date().getTime()}`)
      .then((success) => {
        logXLSEvent(configuration, step);
        const URL = `${front_base_url}/${success.data.payload}?t=${new Date().getTime()}`;
        downloadURI(URL, `${configuration.name}.xls`);
        dispatch(exportXLSSuccess());
        return success.data.payload;
      }).catch((error) => {
        dispatch(exportXLSFailed());
        throw error;
      });
  }
}

export const exportToAML = (configuration) => {
  const mainOverrideString = appConfiguration.main ? `&main=${appConfiguration.main}` : '';
  return async dispatch => {
    dispatch(exportAMLStarted());
    return API_INSTANCE.get(`${api_base_url}/configurations/${configuration.id}/export/aml?locale=${getAppLocale()}${mainOverrideString}&t=${new Date().getTime()}`)
      .then((success) => {
        logExportConfiguration(configuration, 'DOWNLOADS_AML', '.aml');
        const URL = `${front_base_url}/${success.data.payload}`;
        downloadURI(URL, `${configuration.name}.aml`);
        dispatch(exportAMLSuccess());
        return success.data.payload;
      }).catch((error) => {
        dispatch(exportAMLFailed());
        throw error;
      });
  }
}

export const exportToBuyAutomation = (configuration) => {
  return async (dispatch, getState) => {
    const currentStep = getState().configuration?.step || configuration.step;
    dispatch(exportToMyProductStarted());
    return addToBuyAutomation(configuration).then(() => {
      dispatch(exportToMyProductSuccess());
      logAddToBuyAutomationEvent(configuration, currentStep);
    }).catch((error) => {
      dispatch(exportToMyProductFailed());
      throw error;
    });
  }
}

export const exportToMyProject = (configuration) => {
  return async (dispatch, getState) => {
    const currentStep = getState().configuration?.step || configuration.step;
    dispatch(exportToMyProductStarted());
    return addToMyProject(configuration).then(() => {
      dispatch(exportToMyProductSuccess());

      if (appConfiguration.unifiedCheckoutAvailable) {
        logAddToMyCartEvent(configuration, currentStep);
      } else {
        logAddToMyProjectEvent(configuration, currentStep);
      }

    }).catch((error) => {
      dispatch(exportToMyProductFailed());
      throw error;
    });
  }
}

export const exportToMyList = (configuration) => {
  return async (dispatch, getState) => {
    const currentStep = getState().configuration?.step || configuration.step;
    dispatch(exportToMyProductStarted());
    return addToMyList(configuration).then(() => {
      dispatch(exportToMyProductSuccess());
      logAddToMyListEvent(configuration, currentStep);
    }).catch((error) => {
      dispatch(exportToMyProductFailed());
      throw error;
    });
  }
}

export const exportToMyProduct = (configuration) => {
  return async (dispatch, getState) => {
    const currentStep = getState().configuration?.step || configuration.step;
    dispatch(exportToMyProductStarted());
    return addToMyProduct(configuration).then(() => {
      dispatch(exportToMyProductSuccess());
      if (appConfiguration.launchFromWorkspace || appConfiguration.isWorkspaceAvailable) {
        logAddToMyProjectEvent(configuration, currentStep);
      } else {
        logAddToMyProductEvent(configuration, currentStep);
      }
    }).catch((error) => {
      dispatch(exportToMyProductFailed());
      throw error;
    });
  }
}

export const exportToPng = (config) => {
  return async dispatch => {

    dispatch(exportPNGStarted());

    try {
      const useLocalRackDisplayForIslands = !m580_distributed_ranges.includes(config?.rangeInfo?.rangeName);
      const configurationImagesWithName = [];
      const configuration = new Configuration(config);
      let image;
      if (configuration.starterType === possible_starter_selections.PAC) {
        image = await generatePacIslandImage(config, false, useLocalRackDisplayForIslands);
      } else if (configuration.starterType === possible_starter_selections.EDGE) {
        image = await generateEdgeIslandImage(config);
      } else {
        image = await generateIslandImage(config);
      }
      configurationImagesWithName.push({ name: `${configuration.name}.png`, image });

      for (let [rackIdx, rackConfiguration] of configuration.localRacks?.entries()) {
        const isHotstandby = m580_hotstandby_ranges.includes(rackConfiguration.rangeInfo?.rangeName);
        const rackImage = await generatePacIslandImage(rackConfiguration, !isHotstandby, !isHotstandby);
        configurationImagesWithName.push({ name: `${configuration.name} - ${I10n.getAndReplace('saved_configuration.export.pdf.extension_rack', rackIdx + 1)}.png`, image:  rackImage });
      }

      for (let island of configuration.ioIslands) {
        const islandObj = new IOIsland(island);
        let islandImage;
        if (configuration.starterType === possible_starter_selections.PAC) {
          islandImage = await generatePacIslandImage(islandObj.configuration, true, useLocalRackDisplayForIslands);
        } else if (configuration.starterType === possible_starter_selections.EDGE) {
          islandImage = await generateEdgeIslandImage(islandObj.configuration);
        } else {
          islandImage = await generateIslandImage(islandObj.configuration);
        }
        configurationImagesWithName.push({ name: `${islandObj.configuration.name}.png`, image: islandImage });

        for (let [rackIdx, rackConfiguration] of islandObj.configuration.localRacks?.entries()) {
          const rackImage = await generatePacIslandImage(rackConfiguration, true, true);
          configurationImagesWithName.push({ name: `${islandObj.configuration.name} - ${I10n.getAndReplace('saved_configuration.export.pdf.extension_rack', rackIdx + 1)}.png`, image: rackImage });
        }
      }

      if (config.slc) {
        configurationImagesWithName.push({ name: `SLC-${config.slc.module.id}.png`, image: await generateSLCImage(config.slc.module) });
      }

      await downloadConfigurationImages(`${configuration.name}.zip`, configurationImagesWithName);
      logExportConfiguration(configuration, 'EXPORT_PNG', '.zip');
      dispatch(exportPNGSuccess());

    } catch (error) {
      console.log(error);
      dispatch(exportPNGFailed());
    }
  };
}
